var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBehance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "96px",
    height: "96px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,23c1,0 4,-1.618 4,-5.618c0,-6.219 -5.506,-7.382 -11.708,-7.382c-1.172,0 -4.745,0.002 -7.292,0.001c-1.657,-0.001 -3,1.343 -3,3v21.999c0,1.657 1.343,3 3,3h11.8c4.419,0 8.165,-3.496 8.2,-7.915c0.047,-6.076 -5,-7.085 -5,-7.085zM8,15h7c1.657,0 3,1.343 3,3c0,1.657 -1.343,3 -3,3h-7zM15.5,33h-7.5v-7h7.5c1.933,0 3.5,1.567 3.5,3.5c0,1.933 -1.567,3.5 -3.5,3.5zM45.51,29c0.829,0 1.5,-0.671 1.501,-1.5v0c0,-5.799 -4.011,-10.5 -10,-10.5c-5.523,0 -10,4.701 -10,10.5c0,5.799 4.477,10.5 10,10.5c4.887,0 7.602,-2.286 8.928,-5.643c0.256,-0.647 -0.246,-1.348 -0.942,-1.348h-2.401c-0.365,0 -0.688,0.207 -0.877,0.52c-0.914,1.51 -2.309,2.471 -4.187,2.471c-2.812,0 -4.86,-2.135 -5.382,-5h10.722zM37.011,21c2.077,0 4.09,1.656 4.658,4h-9.273c0.753,-2.349 2.535,-4 4.615,-4zM41.5,15h-8c-0.828,0 -1.5,-0.672 -1.5,-1.5v0c0,-0.828 0.672,-1.5 1.5,-1.5h8c0.828,0 1.5,0.672 1.5,1.5v0c0,0.828 -0.672,1.5 -1.5,1.5z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/behance.1159b1703a70ee2b3c3cff2e9b840b0d.svg";
export { ForwardRef as ReactComponent };